import { HabitatModel } from '@akin-home/habitats';
import { habitatModelToUpdateGraphql } from '@akin-home/habitats/frontend';
import { handleImageFieldsOnPost } from '@akin-home/images/frontend';
import { useUpdateHabitat } from './useUpdateHabitat';

export const useUpdateHabitatModel = () => {
  const update = useUpdateHabitat();

  return async (habitat: HabitatModel) => {
    const habitat_with_image_fields = await handleImageFieldsOnPost(habitat, {
      habitatID: habitat.habitatID,
    });

    return update.mutateAsync({
      input: habitatModelToUpdateGraphql(habitat_with_image_fields),
    });
  };
};
